<template>
	<div class="login-container">
		<div class="login-wrapper">
			<!-- 左侧品牌区域 -->


			<!-- 右侧登录表单 -->
			<div class="form-section">
				<div class="form-wrapper">
					<div class="form-header">
						<div class="u-flex" style="justify-content: space-between;">
							<img src="../../assets/logo1.png" class="logo" />
							<!-- <i class="el-icon-close"></i> -->
						</div>
						<h2 class="form-title">重設密碼</h2>
					</div>

					<div class="login-form" @submit.prevent="handleLogin">
						<!-- Email 输入 -->
						<div class="form-group">
							<label class="form-label">帳號</label>
							<div class="input-wrapper">
								<input type="text" class="form-input" placeholder="電子信箱" v-model="form.email" />
							</div>
						</div>

						<!-- Email 输入 -->
						<div class="form-group">
							<label class="form-label">驗證碼</label>
							<div class="input-wrapper u-flex">
								<input type="text" class="form-input" placeholder="請輸入驗證碼" v-model="form.code" />
								<button class="login-button code-button">
									<span class="button-text" @click="toSend">
										{{second==60?'取得驗證碼':second+'s'}}

									</span>
								</button>

							</div>
						</div>
						<div class="form-group">
							<label class="form-label">新密碼</label>
							<div class="input-wrapper">
								<input :type="showPassword ? 'text' : 'password'" class="form-input"
									placeholder="請輸入新密碼" v-model="form.password" />
								<button type="button" class="password-toggle" @click="showPassword = !showPassword">
									<!-- <span class="toggle-icon">{{ showPassword ? '隱藏' : '顯示' }}</span> -->
								</button>
							</div>
						</div>
						<!-- 密码输入 -->
						<div class="form-group" style="margin-bottom: 0.12rem;">
							<label class="form-label">確認新密碼</label>
							<div class="input-wrapper">
								<input :type="showPassword ? 'text' : 'password'" class="form-input"
									placeholder="請再次輸入新密碼" v-model="form.passwordNew" />
								<button type="button" class="password-toggle" @click="showPassword = !showPassword">
									<!-- <span class="toggle-icon">{{ showPassword ? '隱藏' : '顯示' }}</span> -->
								</button>
							</div>
						</div>

						<!-- 服务提示 -->
						<!-- <div class="check-tips">
				<el-checkbox style="margin-right: 0.08rem;" v-model="checked"></el-checkbox>我已同意隱私服務《XXXXX》
			</div> -->

						<!-- 登录按钮 -->
						<button type="submit" class="login-button">
							<span class="button-text" @click="toRest">確認變更
							</span>
						</button>

						<!-- 辅助链接 -->
						<div class="helper-links">
							<a href="#" class="helper-link" @click="goToPage('/login')">取消</a>
							<!-- <span class="link-separator">|</span>
              <a href="#" class="helper-link">註冊新帳號</a> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LoginPage',
		data() {
			return {
				checked: false,
				form: {
					email: '',
					password: '',
					passwordNew: '',
					code: ''
				},
				second: 60,
				showPassword: false
			}
		},
		methods: {
			toSend() {

				if (this.second != 60) {
					return
				}

				this.$axios
					.post("rest-api/system/app/common/email/send/code", {
						email: this.form.email
					})
					.then((res) => {

						if (res.code == 200) {
							var interval = setInterval(() => {
								this.second -= 1;
							}, 1000);
							setTimeout(() => {
								clearInterval(interval);
								this.second = 60;
							}, 60000);
							this.$message({
								message: '發送成功',
								type: 'success'
							});

						} else {
							this.$message({
								message: res.message,
								type: 'error'
							});
						}

					})

			},

			toRest() {



				const that = this;
				// || !this.isGoogleGmail(that.post.email)
				if (!that.form.email) {

					that.$message({
						message: '請輸入正確的電子信箱',
						type: 'error'
					});
					return
				}
				if (!that.form.code) {

					that.$message({
						message: '請輸入驗證碼',
						type: 'error'
					});
					return
				}
				if (!that.form.password) {

					that.$message({
						message: '請輸入新密碼',
						type: 'error'
					});
					return
				}
				if (that.form.password !=that.form.passwordNew) {

					that.$message({
						message: '兩次輸入的密碼不一致',
						type: 'error'
					});
					return
				}
				that.$axios
					.post("rest-api/system/app/user/reset/pwd", that.form)
					.then((res) => {

						this.$message({
							message: '重置成功，請重新登入',
							type: 'success'
						});

						this.goToPage('/login');
					})
					.catch((err) => {});




			},
			toIndex() {
				this.goToPage('/index');
			},
			handleLogin() {
				// 这里处理登录逻辑
				console.log('登录信息:', this.form)
				// 实际项目中这里会调用登录API
			}
		}
	}
</script>

<style scoped lang="scss">
	.login-container {
		min-height: 100vh;
		background: url('../../assets/bg-login.png') no-repeat center;
		background-size: cover;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0.4rem;
	}

	.login-wrapper {
		position: fixed;
		right: 1.4rem;
		width: 5.6rem;
		background: white;
		border-radius: 0.2rem;
		box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.1);
		overflow: hidden;
		display: flex;
		min-height: 4rem;
	}

	/* 左侧品牌区域 */
	.brand-section {
		flex: 1;
		background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0.4rem;
	}

	.brand-content {
		text-align: center;
	}

	.brand-title {
		font-size: 0.48rem;
		font-weight: 700;
		margin-bottom: 0.2rem;
		font-family: 'Microsoft JhengHei', '微軟正黑體', sans-serif;
	}

	.brand-subtitle {
		font-size: 0.2rem;
		opacity: 0.9;
		font-weight: 300;
	}

	/* 右侧表单区域 */
	.form-section {
		flex: 1;
		padding: 0.5rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.form-wrapper {
		width: 100%;
	}

	.form-header {
		// text-align: center;
		margin-bottom: 0.2rem;

		.logo {
			width: 1.14rem;
			height: 0.32rem;
		}

		.el-icon-close {
			font-size: 0.26rem;
			cursor: pointer;
			font-weight: bold;
		}
	}

	.form-title {
		font-size: 0.32rem;
		font-weight: bold;
		color: #1f2937;
		margin: 0.2rem 0 0;
		font-family: 'Microsoft JhengHei', '微軟正黑體', sans-serif;
	}

	.form-subtitle {
		font-size: 0.2rem;
		color: #6b7280;
	}

	/* 表单样式 */
	.login-form {
		width: 100%;
	}

	.form-group {
		margin-bottom: 0.2rem;
	}

	.form-label {
		display: block;
		font-size: 0.2rem;
		font-weight: 500;
		color: #444;
		margin-bottom: 0.12rem;
	}

	.input-wrapper {
		position: relative;
	}

	.form-input {
		width: 100%;
		padding: 0.12rem 0.2rem;
		border: 1px solid #91A2A480;
		border-radius: 0.08rem;
		font-size: 0.2rem;
		transition: all 0.3s ease;
		background: #91A2A41A;

	}

	// .form-input:focus {
	// 	outline: none;
	// 	border-color: #4f46e5;
	// 	background: white;
	// 	box-shadow: 0 0 0 0.03rem rgba(79, 70, 229, 0.1);
	// }

	.form-input::placeholder {
		color: #9ca3af;
	}

	.password-toggle {
		position: absolute;
		right: 0.12rem;
		top: 50%;
		transform: translateY(-50%);
		background: none;
		border: none;
		color: #6b7280;
		font-size: 0.12rem;
		cursor: pointer;
		padding: 0.04rem 0.08rem;
		border-radius: 0.04rem;
		transition: color 0.3s ease;
	}

	.password-toggle:hover {
		color: #374151;
	}

	/* 服务提示 */
	.service-notice {
		background: #f3f4f6;
		border-radius: 0.08rem;
		padding: 0.2rem;
		margin: 0.24rem 0;
		border-left: 0.03rem solid #4f46e5;
	}

	.notice-item {
		margin-bottom: 0.08rem;
	}

	.notice-item:last-child {
		margin-bottom: 0;
	}

	.notice-text {
		font-size: 0.12rem;
		color: #6b7280;
		line-height: 1.4;
	}

	/* 登录按钮 */
	.login-button {
		width: 100%;
		background: #0BA29B;
		color: white;
		border: none;
		border-radius: 0.08rem;
		padding: 0.2rem;
		font-size: 0.2rem;
		font-weight: bold;
		cursor: pointer;
		transition: all 0.3s ease;
		margin-top: 0.2rem;

		&.code-button {
			width: 2rem;
			margin: 0;
			padding: 0.17rem 0.2rem;
			margin-left: 0.1rem;
		}
	}

	// .login-button:hover {
	//   transform: translateY(-0.01rem);
	//   box-shadow: 0 0.04rem 0.12rem rgba(79, 70, 229, 0.4);
	// }

	.login-button:active {
		transform: translateY(0);
	}



	/* 辅助链接 */
	.helper-links {
		text-align: center;
		margin-top: 0.24rem;
		// padding-top: 0.24rem;
		// border-top: 0.01rem solid #e5e7eb;
	}

	.helper-link {
		font-size: 0.2rem;
		color: #0BA29B;
		text-decoration: none;
		transition: color 0.3s ease;
	}

	.helper-link:hover {
		color: #4f46e5;
	}

	.link-separator {
		color: #d1d5db;
		margin: 0 0.08rem;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.login-wrapper {
			flex-direction: column;
			position: inherit;
			max-width: 4.8rem;
			min-height: auto;
		}

		.brand-section {
			padding: 0.3rem;
			min-height: 2rem;
		}

		.brand-title {
			font-size: 0.36rem;
			margin-bottom: 0.12rem;
		}

		.brand-subtitle {
			font-size: 0.2rem;
		}

		.form-section {
			padding: 0.3rem;
		}

		.form-wrapper {
			max-width: none;
		}

		.form-title {
			font-size: 0.28rem;
		}
	}

	@media (max-width: 480px) {
		.login-container {
			padding: 0.1rem;
		}

		.login-wrapper {
			max-width: 100%;
			border-radius: 0.12rem;
		}

		.brand-section {
			padding: 0.24rem;
			min-height: 1.6rem;
		}

		.brand-title {
			font-size: 0.32rem;
		}

		.brand-subtitle {
			font-size: 0.2rem;
		}

		.form-section {
			padding: 0.24rem;
		}

		.form-title {
			font-size: 0.24rem;
		}

		.form-input {
			padding: 0.1rem 0.12rem;
			font-size: 0.2rem;
		}

		.login-button {
			padding: 0.12rem;
			font-size: 0.2rem;
		}
	}

	/* 超小屏幕适配 */
	@media (max-width: 320px) {
		.brand-title {
			font-size: 0.28rem;
		}

		.form-title {
			font-size: 0.2rem;
		}

		.form-input {
			padding: 0.08rem 0.1rem;
		}

		.service-notice {
			padding: 0.12rem;
		}

		.notice-text {
			font-size: 0.11rem;
		}
	}

	.check-tips {
		font-size: 0.2rem;
		color: #999;
	}
</style>